import { GroundType } from 'models/ground';
import { GroundGeometry } from 'types/webPlayer';
import React, { useMemo } from 'react';
import { Group, Line } from 'react-konva';
import { DEFAULT_PITCH_LINE_COLOR, DEFAULT_PITCH_STROKEWIDTH } from '../constants';
import { CenterVertices } from '../../../vectorGround/VectorGround';
import Vertices from '../Vertices';

export default function Volleyball(props: {
  groundData: GroundType;
  scale: number;
  vertices: boolean;
  groundGeometry: GroundGeometry & {centerVertices: CenterVertices};
}) {
  const {groundData, vertices, groundGeometry, scale} = props;

  const geometry = useMemo(() => {
    const {
      center, vertex: vertexPoints, centerVertices, dims,
    } = groundGeometry;

    const { width } = dims;

    return {
      vertexPoints,
      scale,
      center,
      centerVertices,
      line1: [
        vertexPoints.vertexA.x, vertexPoints.vertexA.y,
        vertexPoints.vertexB.x, vertexPoints.vertexB.y,
        vertexPoints.vertexC.x, vertexPoints.vertexC.y,
        vertexPoints.vertexD.x, vertexPoints.vertexD.y,
      ],
      centerLine: [
        groundGeometry.centerVertices?.top?.x || 0, groundGeometry.centerVertices?.top?.y || 0,
        groundGeometry.centerVertices?.bottom?.x || 0, groundGeometry.centerVertices?.bottom?.y || 0,
      ],
      lineArea1: [
        vertexPoints.vertexB.x - width / 3, vertexPoints.vertexB.y,
        vertexPoints.vertexA.x - width / 3, vertexPoints.vertexA.y,
      ],
      lineArea2: [
        vertexPoints.vertexB.x - width / 3 * 2, vertexPoints.vertexB.y,
        vertexPoints.vertexA.x - width / 3 * 2, vertexPoints.vertexA.y,
      ],
    };
  }, [groundGeometry]);

  return (
    <Group>
      {vertices ? <Vertices A={groundGeometry.vertex.vertexA} C={groundGeometry.vertex.vertexC} /> : null}

      {/* perimetro esterno */}
      <Line
        fill={groundData.groundSurfaceColor ? groundData.groundSurfaceColor : '#00000000'}
        points={geometry.line1}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
        closed
      />

      {/* linea metà campo */}
      <Line
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
        points={geometry.centerLine}
      />

      {/* linee interne aree */}

      <Line
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
        points={geometry.lineArea1}
      />
      <Line
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
        points={geometry.lineArea2}
      />

    </Group>
  );
}
